module.exports = __webpack_public_path__ + "img/sun.ff33f0de.png";